import React from 'react'
import logoWhite from '../assets/logo-white.png'

const HEIGHT = {
  header: 'h-9',
  nav: 'h-10',
  footer: 'h-8',
  auth: 'h-12',
  loading: 'h-14'
}

/**
 * Style AI wordmark (white on transparent). Use on dark surfaces only.
 */
export default function BrandLogo({
  size = 'header',
  className = '',
  alt = 'Style AI',
  ...props
}) {
  return (
    <img
      src={logoWhite}
      alt={alt}
      draggable={false}
      className={`w-auto max-w-none object-contain select-none ${HEIGHT[size] || HEIGHT.header} ${className}`}
      {...props}
    />
  )
}
